import {TitanRace1} from "../components/TermsAndConditions/TitanRace1";
import {MainRace1} from "../components/TermsAndConditions/MainRace1";
import {GemsRace} from "../components/TermsAndConditions/GemsRace";
import {LightningRace1} from "../components/TermsAndConditions/LightningRace1";
import {ChillRace} from "../components/TermsAndConditions/ChillRace";
import {TitanRace2} from "../components/TermsAndConditions/TitanRace2";
import {MainRace2} from "../components/TermsAndConditions/MainRace2";
import {LightningRace2} from "../components/TermsAndConditions/LightningRace2";
import {TitanRace3} from "../components/TermsAndConditions/TitanRace3";
import {MainRace3} from "../components/TermsAndConditions/MainRace3";
import {TitanRace4} from "../components/TermsAndConditions/TitanRace4";
import {MainRace4} from "../components/TermsAndConditions/MainRace4";
import {TitanRace5} from "../components/TermsAndConditions/TitanRace5";
import {MainRace5} from "../components/TermsAndConditions/MainRace5";
import {MegawaysRace} from "../components/TermsAndConditions/MegawaysRace";
import {HalloweenRace} from "../components/TermsAndConditions/HalloweenRace";
import {CashMain} from '../components/TermsAndConditions/CashMain'
import {CashGold} from '../components/TermsAndConditions/CashGold'
import {CashVip} from '../components/TermsAndConditions/CashVip'
import {Nuggets} from "../components/TermsAndConditions/Nuggets";
import {Playson} from "../components/TermsAndConditions/Playson";
import {Fantasma} from "../components/TermsAndConditions/Fantasma";
import {Buffalo} from "../components/TermsAndConditions/Buffalo";

import {MainFAQ} from '../components/faq/MainFAQ'
import {TitanFAQ} from '../components/faq/TitanFAQ'
import {GemsFAQ} from '../components/faq/GemsFAQ'
import {LightningFAQ} from '../components/faq/LightningFAQ'
import {ChillFAQ} from '../components/faq/ChillFAQ'
import {MegawaysFAQ} from '../components/faq/MegawaysFAQ'
import {HalloweenFAQ} from '../components/faq/HalloweenFAQ'
import {CashMainFAQ} from '../components/faq/CashMainFAQ'
import {CashGoldFAQ} from '../components/faq/CashGoldFAQ'
import {CashVipFAQ} from '../components/faq/CashVipFAQ'
import {NuggetsFAQ} from "../components/faq/NuggetsFAQ";
import {PlaysonFAQ} from "../components/faq/PlaysonFAQ";
import {FantasmaFAQ} from "../components/faq/FantasmaFAQ";
import {BuffaloFAQ} from "../components/faq/BuffaloFAQ";
import {FruitopolisFAQ} from "../components/faq/FruitopolisFAQ";
import {Fruitopolis} from "../components/TermsAndConditions/Fruitopolis";


export const debugMode = false

export const baseURL = process.env.REACT_APP_API_URL

export const totalPrizes = '1.561.000 RON'

export const currentPrize = '14.000 RON'

export const maxUsernameLength = 10

export const racesTermsAndConditions = {
    'titan-race': <TitanRace1 />,
    'main-race': <MainRace1 />,
    'gems-race': <GemsRace />,
    'lightning-race': <LightningRace1 />,
    'chill-race': <ChillRace />,
    'titan-race-2': <TitanRace2 />,
    'main-race-2': <MainRace2 />,
    'lightning-race-2': <LightningRace2 />,
    'titan-race-3': <TitanRace3 />,
    'main-race-3': <MainRace3 />,
    'titan-race-4': <TitanRace4 />,
    'main-race-4': <MainRace4 />,
    'titan-race-5': <TitanRace5 />,
    'main-race-5': <MainRace5 />,
    'megaways': <MegawaysRace />,
    'halloween': <HalloweenRace />,
    'cash-main': <CashMain />,
    'cash-gold': <CashGold />,
    'cash-vip': <CashVip />,
    'nuggets': <Nuggets />,
    'playson': <Playson />,
    'fantasma': <Fantasma />,
    'buffalo': <Buffalo />,
    'fruitopolis': <Fruitopolis />
}

export const dailyTableNames = {
    'Premii misterioase': ['lightning-race', 'chill-race', 'main-race-2', 'titan-race-2', 'lightning-race-2']
}

export const racesNames = {
    'mainRaces' : {
        raceCode: 'main-race',
        title:'Cursa Principală',
        faqInfo: <MainFAQ />
    },
    'titanRaces' : {
        raceCode: 'titan-race',
        title: 'Cursa Titanilor',
        faqInfo: <TitanFAQ />
    },
    'bookOfGemsRaces' : {
        raceCode: 'gems-race',
        title: 'Cursa Book of GEMS',
        faqInfo: <GemsFAQ />
    },
    'lightningRaces' : {
        raceCode: 'lightning-race',
        title: 'Cursa Fulger',
        faqInfo: <LightningFAQ />
    },
    'princessAndChillRaces' : {
        raceCode: 'chill-race',
        title:'Princess & Chill',
        faqInfo: <ChillFAQ />
    },
    'megawaysRaces' : {
        raceCode: 'megaways',
        title: 'Cursa Megaways',
        faqInfo: <MegawaysFAQ />
    },
    'halloweenRaces': {
        raceCode: 'halloween',
        title:'Cursa Halloween',
        faqInfo: <HalloweenFAQ />
    },
    'cashMainRace':{
        raceCode: 'cash-main',
        title:'Cursa Principală',
        faqInfo: <CashMainFAQ />
    },
    'cashGoldRace':{
        raceCode: 'cash-gold',
        title:'Cursa Golden',
        faqInfo: <CashGoldFAQ />
    },
    'cashVipRace':{
        raceCode: 'cash-vip',
        title: 'Cursa VIP',
        faqInfo: <CashVipFAQ />
    },
    'nuggets':{
        raceCode: 'nuggets',
        title: 'Ninja Chicken Race',
        faqInfo: <NuggetsFAQ />
    },
    'playson':{
        raceCode: 'playson',
        title: 'Cursa Playson',
        faqInfo: <PlaysonFAQ />
    },
    'fantasma':{
        raceCode: 'fantasma',
        title: 'Cursa Fantasma',
        faqInfo: <FantasmaFAQ/>
    },
    'buffalo':{
        raceCode: 'buffalo',
        title: 'Cursa Buffalo',
        faqInfo: <BuffaloFAQ />
    },
    'fruitopolis':{
        raceCode: 'fruitopolis',
        title: 'Cursa Fruitopolis',
        faqInfo: <FruitopolisFAQ />
    }
}

export const racesLinks = {
    'halloween' : 'https://www.princesscasino.ro/tournament-games',
    'chill-race' : 'https://www.princesscasino.ro/tournament-games',
    'gems-race' : 'https://www.princesscasino.ro/?modal=login&game-after-login=skywind-book-of-gems-megaways',
    'nuggets' : 'https://www.princesscasino.ro/selection-games/skywind-nunchucks-chicken/real',
    'playson': 'https://www.princesscasino.ro/tournament-games',
    'fantasma': 'https://www.princesscasino.ro/tournament-games',
    'buffalo': 'https://www.princesscasino.ro/slots-games/skywind-big-buffalo-badlands/real',
    'fruitopolis': 'https://www.princesscasino.ro/all-games/skywind-fruitopolis/real'
}

